import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

type TAppStore = {
  headerConfig: {
    title: string;
    subtitle: string;
    hasBackArrow: boolean;
    backArrowTo: string | -1 | null;
    helmetTitle: string;
    chosenBankName: string | null;
  };

  wsIsConnected: boolean;
};

const initialState: TAppStore = {
  headerConfig: {
    title: '',
    subtitle: '',
    hasBackArrow: false,
    backArrowTo: null,
    helmetTitle: '',
    chosenBankName: null
  },

  wsIsConnected: false
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<TAppStore['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload
      };
    },
    setWsIsConnected(state, action: PayloadAction<boolean>) {
      state.wsIsConnected = action.payload;
    }
  }
});

export const { setHeaderConfig, setWsIsConnected } = appSlice.actions;
